@if (type === 'Products') {
<prod-menu
  [title]="title"
  [products]="menuContent.children"
  [specialMenuTitle]="menuContent['special-menu-title']"
  [specialMenuPath]="menuContent['special-menu-path']"
  (closeMenuEvent)="closeNavEventHandler()">
</prod-menu>
} @if (type === 'Solutions') {
<solution-menu
  [title]="title"
  [products]="menuContent.children"
  (closeMenuEvent)="closeNavEventHandler()"></solution-menu>
} @if (type === 'Resource') {
<resource-menu
  [title]="title"
  [resources]="menuContent.children"
  (closeMenuEvent)="closeNavEventHandler()"></resource-menu>
}
